import { FrontendApplication, StorageService, WidgetManager } from '@theia/core/lib/browser';
import { ShellLayoutRestorer } from '@theia/core/lib/browser/shell/shell-layout-restorer';
import { ILogger } from '@theia/core/lib/common/logger';
import { inject, injectable } from '@theia/core/shared/inversify';

@injectable()
export class BrowserOnlyShellLayoutRestorer extends ShellLayoutRestorer {
    constructor(
        @inject(WidgetManager) widgetManager: WidgetManager,
        @inject(ILogger) logger: ILogger,
        @inject(StorageService) storageService: StorageService
    ) {
        super(widgetManager, logger, storageService);
    }

    override storeLayout(_app: FrontendApplication): void {
        void this.storageService.setData(this.storageKey, undefined);
    }

    override async restoreLayout(_app: FrontendApplication): Promise<boolean> {
        await this.storageService.setData(this.storageKey, undefined);
        return false;
    }
}
